import $api from "@/core/services/ApiService";
import { AxiosRequestConfig, AxiosResponse } from "axios";

class GoogleAuth {
  public qrCode(params: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return $api.get("profile/2fa/google/qr-code", params);
  }

  public assign(params: {
    secret: string;
    code: string;
  }): Promise<AxiosResponse> {
    return $api.post("profile/2fa/google/assign", params as AxiosRequestConfig);
  }

  public remove(): Promise<AxiosResponse> {
    return $api.delete("profile/2fa/google/remove");
  }
}

class TwoFactorAuth {
  public google: GoogleAuth = new GoogleAuth();
}

export default TwoFactorAuth;
